export default __webpack_public_path__ + "static/media/support-org1.b6aafe1f.png";